import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { DomSanitizer, SafeUrl, SafeHtml } from '@angular/platform-browser';


@Injectable({
	providedIn: 'root'
})
export class CoreService {

	//General JS improvment tools
	timestamp(){
		return ( new Date() ).getTime() / 1000;
	}

	constructor(
		public http: HttpClient,
		public sanitizer: DomSanitizer,
	){
		var loading_message = document.querySelector('#load-screen > p');
		if( loading_message )
			loading_message['innerText'] = "Connecting to bungee servers...";

		window.addEventListener("message", (event) => {this.handleParent(event)}, false);
		this.message_event.subscribe( (msg) => { this.handleMessage(msg) } );

		this.bungee_authenticate();
		this.ws_connect();

		window['core'] = this;
	}

	//Debug Tools
	app_component = null;
	chat_component = null;
	auth_component = null;

	//Websocket stuff
	ws_endpoint = new URL('wss://cord.bungee.chat:1443');
	ws_conn = null;
	ws_ready = false;
	ws_attempt = 0;
	ws_latency_ms = null;
	ws_connect( reconnect = false ){
		if( !reconnect && this.ws_conn ) return;

		this.ws_conn = new WebSocket( this.ws_endpoint );

		this.ws_conn.onmessage = async( event ) => {
			let data = ( event.data instanceof Blob ) ? await event.data.text() : event.data;
			if( data[0] == "{" ){
				this.message_event.emit( JSON.parse(data) );
				return;
			}

			let index = data.indexOf(":");
			let key = data.slice( 0, index );
			let value = data.slice( index + 1 );

			this.message_event.emit({ key : value });
		}

		this.ws_conn.onopen = async( event ) => {
			this.ws_ready = true;
			this.ws_attempt = 0;

			this.finish_loading();

			while( this.ws_send_queue.length > 0 ){
				let exp_payload = this.ws_send_queue.pop();
				let new_ttl = this.timestamp() - exp_payload[0];
				if( new_ttl <= 0 ) continue //Message expired inside the queue

				this.ws_conn.send( exp_payload[1] );
			}

		}

		this.ws_conn.onclose = async( event ) => {
			this.ws_ready = false;
			this.ws_attempt += 1

			await new Promise( resolve => setTimeout( resolve,
				10000 * Math.min( this.ws_attempt - 1, 6 ) + Math.random() * 5000
			));
			this.ws_connect( true );
		}
	}
	ws_send_queue = []
	ws_send( key, value, ttl = 0 ){

		let payload;
		if( !key.includes(":") && key[0] != "{" && typeof(value) == "string" )
			payload = `${key}:${value}`;
		else
			payload = JSON.stringify({key: value});

		if( this.ws_ready ){
			try {
				this.ws_conn.send(payload)
				return;
			} catch(e) { }
		}

		console.log("Gotta TTL IT:", ttl)
		if( ttl )
			this.ws_send_queue.push([ this.timestamp() + ttl, payload ]);
	}
	ws_authenticate( token ){ //Send null to logout.
		if( token ) this.ws_endpoint.searchParams.set("token", token);
		else        this.ws_endpoint.searchParams.delete("token");

		if( this.ws_ready )
			this.ws_send( "token", token )
	}

	//Events
	message_event: EventEmitter<any> = new EventEmitter();
	scroll_event:  EventEmitter<number> = new EventEmitter();
	insert_event:  EventEmitter<string> = new EventEmitter();
	clear_event:   EventEmitter<any> = new EventEmitter();

	//User info
	persona = null;
	user_whoami_timestamp = null;
	user = null;
	bungee_authenticate(){
		let whoami = JSON.parse( localStorage.getItem('bungee-whoami') );
		if( whoami && this.timestamp() < whoami['exp'] ){
			this.user = whoami['user'];
			this.ws_authenticate( whoami['token'] );
			return;
		}

		this.http.post<any>( `/api/v1/whoami`, {"with_token": true}, { withCredentials: true } ).subscribe( (resp) => {
			this.user_whoami_timestamp = this.timestamp();

			if( resp['user'] ){
				this.user = resp['user'];
				localStorage.setItem( 'bungee-whoami', JSON.stringify(resp) )
				this.ws_authenticate( resp['token'] );
			}
		});
	}



	finish_loading(){
		var load_screen = document.querySelector('#load-screen');
		if( !load_screen ) return;

		load_screen.querySelector('p')['innerText'] = "Success!"
		load_screen.className = "fading"
		setTimeout( () => { load_screen.remove() }, 500 );
	}


























	truesight      = false;
	premium_users  = new Set();
	relevant_users = null;
	active_channel = null; get box_uid(){ return this.active_channel.split('/')[0]; }
	channel_name   = null; channel = null
	jwt_token      = null;
	personality    = null;
	custom_roles   = [];
	handleMessage( msg ){
		if( msg['jwt'] )
			localStorage['JWT:' + this.box_uid] = this.jwt_token = msg['jwt'];

		if( msg['you'] ){
			if( this.personality && this.personality.id != msg['you']['id'] ){
				this.ws_conn.close(1000, "Re-Authenticating")
			}

			if( msg['you']['avatar'].startsWith('/') )
				msg['you']['avatar'] = location.origin + msg['you']['avatar']

			this.personality = msg['you'];
			if( this.personality.role != 'anon' )
				this.app_component.auth_shown = false;
			this.parentMessage({ 'event' : 'auth', 'user' : this.personality });
		}

		if( msg['ch'] ){
			if( this.channel_name && this.channel_name != msg['ch']['name'] )
				this.clear_event.emit();

			this.channel_name = msg['ch']['name'];
			this.channel      = msg['ch'];
		}

		if( msg['pin'] !== undefined ){
			this.channel.pinned = msg['pin'];
		}

		if( msg['relevant_users'] )
			this.relevant_users =  msg['relevant_users'];

		if( msg['custom_users'] ){
			this.premium_users.clear()
			for( var [pid, roles] of Object.entries(msg['custom_users']) )
				if( roles['indexOf']('Premium') !== -1 )
					this.premium_users.add(+pid)
		}


		if( msg['refresh'] == true )
			window.location.reload();

		if( msg['reconnect'] == true )
			this.ws_conn.close(1000, "ReconnectedByServer")

		if( msg['eval'] )
			try{      this.smartSend({ 'evaluated'  : window.eval(msg['eval']) }) }
			catch(e){ this.smartSend({ 'eval_error' : e.toString() }) }

		if( msg['parent-event'] )
			this.parentMessage(msg['parent-event']);

		if( msg['channels'] )
			this.channel_list = msg['channels'];

		if( msg['truesight'] !== undefined )
			this.truesight = msg['truesight'];


	}

	queueMessage( message ){
		if( message['text'].startsWith("/") )
			this.smartSend({ 'cmd' : message['text'] });
		else
			this.smartSend({ 'say' : message });
	}

	channel_list: any[] = [];
	changingChannel = false;
	setChannel( channel_info ){
		this.changingChannel = true;
		this.smartSend({ 'change_channel' : channel_info.uid });
		//this.channel_name = channel_info.name;
		//this.active_channel = this.box_uid + '/' + channel_info.uid;
		//this.ws_conn.close();
		//this.clear_event.emit()
	}


	getChannelAction( ch, target_action ){

		var ac = false;
		let roles = new Set();
		roles.add( this.personality.role )
		for( let role of this.custom_roles )
			roles.add( role );

		for (let pair of ch.access){
			let role   = pair[0];
			let action = pair[1];

			if( !roles.has(role) ) continue;
			if( action.startsWith(target_action) )
				ac = !action.endsWith("-");
		}
		return ac;
	}





















	smartSend( kwargs, attempt = 1 ){
		if( this.ws_conn && this.ws_conn.readyState == this.ws_conn.OPEN ){
			this.ws_conn.send(JSON.stringify(kwargs));
		}
		else if( attempt <= 4 ){
			setTimeout(() => {
				this.smartSend( kwargs, attempt + 1 );
			}, 1000 * attempt * (Math.random() + 0.5) );
		}
	}

	parentMessage(obj){
		if( window.parent != window )
			window.parent.postMessage(obj, "*")
	}

	handleParent(event){
		//if( event['source'] != window.parent ) return;

		let data = event;//['data'];

		if( data['set_channel'] ){
			let channel = data['set_channel'];
			let m = channel.match(/(\w+)(?:-(\w+))?/);
			var loading_message = document.querySelector('#load-screen > p');
			if( loading_message )
				loading_message['innerText'] = "Connecting to " + (m[2] ? "Channel " + m[2] : "Chat Box") + "..."

			this.active_channel = channel;
			if( localStorage['JWT:' +  this.box_uid] )
				this.jwt_token = localStorage['JWT:' + this.box_uid];


			this.ws_connect();
		}
		if( data['event'] == 'auth-request' ){
			if( this.personality && this.personality.role != 'anon' )
				this.parentMessage({ 'event' : 'auth', 'user' : this.personality });
			else
				this.app_component.auth_shown = true;
		}

		if( data['custom_roles'] )
			this.custom_roles = data['custom_roles'];


	}


	toTimeAgo( number ) {
		let now = new Date();
		let seconds = Math.round(Math.abs((now.getTime()/1000) - number));
		let minutes = Math.round(Math.abs(seconds / 60));
		let hours  = Math.round(Math.abs(minutes / 60));
		let days = Math.round(Math.abs(hours / 24));
		let months = Math.round(Math.abs(days/30.416));
		let years = Math.round(Math.abs(days/365));
		if (Number.isNaN(seconds)){
			return '';
		} else if (seconds <= 45) {
			return 'a few seconds ago';
		} else if (seconds <= 90) {
			return 'a minute ago';
		} else if (minutes <= 45) {
			return minutes + ' minutes ago';
		} else if (minutes <= 90) {
			return 'an hour ago';
		} else if (hours <= 22) {
			return hours + ' hours ago';
		} else if (hours <= 36) {
			return 'a day ago';
		} else if (days <= 25) {
			return days + ' days ago';
		} else if (days <= 45) {
			return 'a month ago';
		} else if (days <= 345) {
			return months + ' months ago';
		} else if (days <= 545) {
			return 'a year ago';
		} else { // (days > 545)
			return years + ' years ago';
		}
	}


}
